import React, { Fragment } from "react";
import { Checkbox, ColorPicker, Tooltip } from "antd";
import { TableOutlined, LoadingOutlined, DoubleRightOutlined, DoubleLeftOutlined } from '@ant-design/icons';
import { getTextWidth } from "@/services/helper/getTextWidth";
import { strDelimited } from "@/services/helper/split";
import { nodeLabelRender } from "@/components/ResultTreeList/nodeRender";
import "./new.css";

const RESULT_TREE_SIGNAL = "resultTreeSignal", RESULT_TREE_SWEEP_PIN = "resultTreeSweepPin", WAVEFORM_PIN = "waveformPin";
/**
 *  
 * tree node title
 * //waveform -> color Usage comp-pin,curve value
 * */
function waveformPinTitle(nodeData, action) {
  const { color, id, value, pcb, parentKey } = nodeData || {};
  const { isPostProcess, recalc, changePostProcessVisible, currentPostProcessData, ResultPostProcess } = action || {}
  //mouse hover curve value
  const _value = action.curveMouseObj ? action.curveMouseObj[id] || "" : value;
  const currentValueWidth = _value ? getTextWidth(_value, 14, 100, "bold") + 10 : 10;
  const labelWidth = `calc(100% - ${(16 + 18 + currentValueWidth)}px)`;//16: checkbox, 18: post processing icon
  const pcbColor = (action.designs || []).find(item => item.name === pcb);

  const isTableHighlightClassName = isPostProcess && nodeData.postProcessData
    && currentPostProcessData &&
    currentPostProcessData.title === nodeData.postProcessData.title
    && currentPostProcessData.signal === nodeData.postProcessData.signal ? "aurora-result-highLight-table-icon" : "";

  const showPostProcessing = isPostProcess && nodeData.postProcessData && Object.keys(nodeData.postProcessData).length && nodeData.postProcessData.curveName;

  return <div className='result-tree-node-content result-tree-node-content-include-post'>
    <div className={showPostProcessing ? "result-tree-node-title result-tree-node-include-post-title" : 'result-tree-node-title'}>
      <ColorPicker
        value={color}
        className='aurora-color-picker-small'
        onChange={(value) => action.colorChange(value, id, parentKey)}
        size='small'
        onClick={(e) => action.stopPropagation(e)}
        id={`col::${id}`}
      />
      {action.customizeTitle ? <label
        htmlFor={`col::${id}`}
        style={{ width: labelWidth }}
      >{action.customizeTitle(nodeData)}</label>
        : nodeLabelRender({ ...nodeData, labelWidth, pcbColor })
      }
      <span className='result-tree-curve-current' style={{ color }}>{isNaN(parseFloat(_value)) ? '' : _value}</span>
      {(showPostProcessing && changePostProcessVisible) ?
        (recalc ? <LoadingOutlined className="result-tree-group-postProcess-icon" title="Recalculating..." />
          : <TableOutlined onClick={(e) => { changePostProcessVisible(e, '', nodeData.postProcessData, parentKey, id) }}
            className={`result-tree-group-postProcess-icon ${isTableHighlightClassName}`}
          />) : null
      }
    </div>
    {ResultPostProcess && isPostProcess && ResultPostProcess(nodeData.postProcessData)}
  </div>
}

/* row node (signal) */
function getSignalTitle(nodeData, action) {
  const { isPostProcess, postProcessTitle, experimentList = [], sweepTimeShowList = [], changeSelectAll } = action;
  const isParallel = action.isParallel && experimentList && experimentList.length

  return <div className="result-tree-row-node-content">
    {/* signal name */}
    <div className="result-tree-row-node-title-content">
      {/* Solve the problem that data cannot be covered when scrolling */}
      <div className="placeholder-elements"></div>
      <Tooltip
        title={nodeData.title || nodeData.name || nodeData.rowName || ""}
        placement="topLeft"
        classNames={{ root: 'aurora-tooltip' }}>
        <span className="result-tree-row-node-title">
          {nodeData.title || nodeData.name || nodeData.rowName || ""}
        </span>
      </Tooltip>
    </div>
    {/* waveform post processing max min */}
    {!action.isParallel && isPostProcess && postProcessTitle ? postProcessTitle() : null}
    {/* sweep waveform exp signal checkbox and post processing max min */}
    {isParallel ?
      experimentList.map(expItem => {
        const { indeterminate, checked } = action.getSweepChecked(expItem.name, nodeData.id);
        return <div className="result-tree-experiment-title-check-item" key={expItem.name}>
          <div className="result-tree-experiment-list-exp-item">
            <Checkbox
              indeterminate={indeterminate}
              onChange={(e) => changeSelectAll(e, "signal", expItem.name, nodeData.id)}
              checked={checked}
            ></Checkbox>
          </div>
          {isPostProcess && postProcessTitle && (sweepTimeShowList || []).includes(expItem.name) ? postProcessTitle() : null}
        </div>
      })
      : null}
  </div>
}

/* experiment list title  - Result - Rising Falling */
function experimentListTitleRender(props) {
  const { isPostProcess, postProcessTitle, experimentList = [], showSweepTime, sweepTimeShowList = [], displayMode } = props;
  return <div className="result-tree-experiment-list-title-content">
    {experimentList.map(expItem =>
      <Fragment key={expItem.id}>
        <div className="result-tree-experiment-list-exp-item">
          <Tooltip
            title={expItem.name}
            classNames={{ root: 'aurora-tooltip' }}>
            <span
              className={displayMode === "Waveform" ? 'result-tree-experiment-waveform-exp-title' : 'result-tree-experiment-sparameter-exp-title'}
            >
              {expItem.name}</span>
          </Tooltip>
          {displayMode === "Waveform" ? (sweepTimeShowList || []).includes(expItem.name) ?
            <DoubleLeftOutlined
              onClick={() => showSweepTime(expItem.name, false)}
              className='result-tree-exp-title-icon'
              title="Hide Rising and Falling"
            />
            : <DoubleRightOutlined
              onClick={() => showSweepTime(expItem.name, true)}
              className='result-tree-exp-title-icon'
              title="Show Rising and Falling" /> : null}
        </div>
        {isPostProcess && postProcessTitle && (sweepTimeShowList || []).includes(expItem.name) ? postProcessTitle("resultList", "sweep") : null}
      </Fragment>)}
  </div>
}

function getSweepPinTitle(nodeData, action) {
  const { pcb } = nodeData || {};
  const { experimentList } = action || {};
  const pcbColor = (action.designs || []).find(item => item.name === pcb);

  return <div className='result-tree-node-sweep-content'>
    <div className={"result-tree-node-title result-tree-node-sweep-title"}>
      {/* Solve the problem that data cannot be covered when scrolling */}
      <div className="placeholder-elements"></div>
      {nodeLabelRender({ ...nodeData, labelWidth: "100%", pcbColor })}
    </div>
    {experimentList.map(expItem => { return sweepPinRender({ ...nodeData, pcbColor }, expItem, action) }
    )}
  </div>
}

function sweepPinRender(nodeData, expItem, action) {
  const { color, id, parentKey, currentValue } = nodeData || {};
  const { isPostProcess, changePostProcessVisible, currentPostProcessData, sweepReCalc, ResultPostProcess, sweepTimeShowList, portSelect, isSparameter } = action;
  const portId = strDelimited(id, "@")[1];
  const expPortId = `${expItem.name}@${portId}`;
  const _value = action.curveMouseObj ? action.curveMouseObj[expPortId] || "" : (currentValue ? currentValue[expItem.name] || "" : "");
  const signalId = isSparameter ? strDelimited(parentKey, "::")[0] : parentKey;
  const rowSelect = portSelect ? portSelect[signalId] || [] : [];

  //find current sweep exp post processing result data
  const findPostProcessData = (nodeData.expPostProcessData || {})[expItem.name];
  const showPostProcessing = isPostProcess && findPostProcessData && findPostProcessData && findPostProcessData.curveName === expPortId;

  const isTableHighlightClassName = showPostProcessing && currentPostProcessData && currentPostProcessData.curveName === expPortId && currentPostProcessData.signal === findPostProcessData.signal ? "aurora-result-highLight-table-icon" : "";
  return <div className="result-tree-node-sweep-item-content" key={`${expItem.id}::${id}`}>
    <div className="result-tree-node-sweep-item">
      {color[expItem.name] ? <Fragment>
        <Checkbox
          value={expPortId}
          className="result-tree-node-sweep-item-checkbox"
          checked={rowSelect.includes(expPortId)}
          onChange={(e) => action.changeSinglePort(e, parentKey, expPortId)}
        />
        <ColorPicker
          value={color[expItem.name]}
          className='aurora-color-picker-small'
          onChange={(value) => action.colorChange(value, expPortId, parentKey)}
          size='small'
          onClick={(e) => action.stopPropagation(e)}
          id={`col::${expPortId}`}
        />
        <span className='result-tree-curve-current' style={{ color: color[expItem.name] }}>{isNaN(parseFloat(_value)) ? '' : _value}</span>
        {(showPostProcessing && changePostProcessVisible) ?
          (sweepReCalc && sweepReCalc.includes(expPortId) ? <LoadingOutlined className="result-tree-group-postProcess-icon" title="Recalculating..." />
            : <TableOutlined onClick={(e) => { changePostProcessVisible(e, 'sweep', nodeData.postProcessData, parentKey, expPortId) }}
              className={`result-tree-group-postProcess-icon ${isTableHighlightClassName}`}
            />) : <div className="result-tree-group-postProcess-icon-div"></div>
        }
      </Fragment> : null}
    </div>
    {ResultPostProcess && isPostProcess && (sweepTimeShowList || []).includes(expItem.name) && ResultPostProcess(findPostProcessData)}
  </div>
}

/*  s parameter pcb tile and experiments checkbox title, and waveform sweep experiment checkbox title */
function sweepExpCheckTitle(nodeData, action) {
  const { experimentList, isParallel, changeSelectAll, sweepTimeShowList, isSparameter } = action;
  return <div className='result-tree-node-sweep-check-content'>
    {isSparameter ? <div className="result-tree-experiment-title-check-content">
      <Tooltip
        title={nodeData.rowName || nodeData.name || ""}
        placement="topLeft"
        classNames={{ root: 'aurora-tooltip' }}>
        <span className="result-tree-experiment-title-check">
          {nodeData.rowName || nodeData.name || ""}
        </span>
      </Tooltip>
      {/* Solve the problem that data cannot be covered when scrolling */}
      <div className="placeholder-elements"></div>
    </div>
      : <Fragment>
        <span className="result-tree-experiment-title-check">
          {/* Solve the problem that data cannot be covered when scrolling */}
          <div className="placeholder-elements"></div>
        </span>
      </Fragment>}
    {isParallel && experimentList && experimentList.length ?
      experimentList.map(expItem => {
        const { indeterminate, checked } = action.getSweepChecked(expItem.name, null, nodeData);
        return <div
          key={expItem.name}
          className={(sweepTimeShowList || []).includes(expItem.name) && !isSparameter ? "result-tree-experiment-title-checkbox" : "result-tree-experiment-title-checkbox-hidden"}>
          <Checkbox
            indeterminate={indeterminate}
            onChange={(e) => changeSelectAll(e, "exp", expItem.name, null, nodeData)}
            checked={checked}
          ></Checkbox>
        </div>
      })
      : null}
  </div >
}

function endToEndItemTreeSignalTitle(nodeData) {
  const { title, isShowComp, driverComp, receiverComp, isSinglePCB } = nodeData || {}
  return <Tooltip
    title={`${title}${isShowComp ? `(${driverComp}, ${receiverComp})` : ""}`}
    classNames={{ root: 'aurora-tooltip' }}>
    <div>
      {title}
      {isShowComp ?
        <Fragment>
          <span> (</span>
          <span className='result-tree-end-to-end-title-pcb1'>{driverComp}</span>
          <span>, </span>
          <span className={`result-tree-end-to-end-title-pcb${isSinglePCB ? "1" : "2"}`}>{receiverComp}</span>
          )
        </Fragment> : null}</div>
  </Tooltip>
}

function endToEndItemTreeRowTitle(nodeData) {
  return <div className='result-tree-end-to-end-row'>
    {nodeData.isSinglePCB
      ? <Tooltip
        title={nodeData.PCB1}
        placement="topLeft"
        classNames={{ root: 'aurora-tooltip' }}>
        <span
          className='result-tree-end-to-end-title-pcb1'
          title={nodeData.PCB1}
        >{nodeData.PCB1}</span>

      </Tooltip>
      : <Tooltip
        title={`${nodeData.PCB1} - ${nodeData.PCB2}`}
        placement="topLeft"
        classNames={{ root: 'aurora-tooltip' }}>
        <span>
          <span className='result-tree-end-to-end-title-pcb1'>{nodeData.PCB1}</span>
          <span> - </span>
          <span className='result-tree-end-to-end-title-pcb2'>{nodeData.PCB2}</span>
        </span>
      </Tooltip>}
  </div>
}

function endToEndItemTitle(nodeData, action) {
  const { isSinglePCB, driver, receiver, PCB1, PCB2, curveIndex } = nodeData || {};
  const { displayMode } = action;
  //const color = file.matrix && file.matrix[child.row] && file.matrix[child.row][child.col] ? file.matrix[child.row][child.col].color : "";
  let portNameClassName = (displayMode === "RL" && curveIndex === 0) || isSinglePCB ? "result-tree-end-to-end-title-pcb1-imp" : "";
  portNameClassName = displayMode === "RL" && curveIndex === 1 && !isSinglePCB ? "result-tree-end-to-end-title-pcb2-imp" : portNameClassName;
  return <Tooltip
    title={isSinglePCB ? `S(${driver}, ${receiver})` : `S(${driver}, ${receiver}) (${PCB1}, ${PCB2})`}
    classNames={{ root: 'aurora-tooltip' }}
  >
    <span>S(</span>
    <span className={`result-tree-end-to-end-title-pcb1 ${portNameClassName}`}>{driver}</span>
    <span>, </span>
    <span className={`result-tree-end-to-end-title-pcb2 ${portNameClassName}`}>{receiver}</span>
    <span>)</span>
  </Tooltip>
}

export {
  waveformPinTitle,
  getSignalTitle,
  experimentListTitleRender,
  getSweepPinTitle,
  sweepExpCheckTitle,
  endToEndItemTreeSignalTitle,
  endToEndItemTreeRowTitle,
  endToEndItemTitle,
  RESULT_TREE_SIGNAL,
  RESULT_TREE_SWEEP_PIN,
  WAVEFORM_PIN
}